// import {List, Map} from "immutable";
import URLUtil from "./URLUtil";
import forEach from "lodash/forEach"
import * as packagedeals_actions from "../data/packagedeals/actions_packagedeals.svelte.js";
import * as products_actions from "../data/products/actions_products.svelte.js";
import * as productsets_actions from "../data/productsets/actions_productsets.svelte.js";
import * as progress_actions from "../data/progress/actions_progress.svelte.js";
import * as booking_actions from "../data/booking/actions_booking.svelte.js";
import * as booker_actions from "../data/booker/actions_booker.svelte.js";
import {widgets} from "../data/widgets/feature.widgets.svelte.js";
import {progress} from "../data/progress/feature.progress.svelte.js";
import {booking} from "../data/booking/feature.booking.svelte.js";
import DataLayerUtil from "./DataLayerUtil.js";

class InputUtil {
  static updateInitialStateWithExternalInput = () => {
    //alert('verwerk de meuk initiele config');
    packagedeals_actions.importFromPageConfigAjaxCall();
    products_actions.importFromPageConfigAjaxCall();
    productsets_actions.importFromPageConfigAjaxCall();
    progress_actions.importFromPageConfigAjaxCall();
    booking_actions.importFromPageConfigAjaxCall();
    booker_actions.importFromPageConfigAjaxCall();

    progress.bWasJSONDataFromPageParsed = true;

    DataLayerUtil.eventStartReservation();

    // NB - deze manier van dingen via get doorgeven is niet meer wat we doen - zie start ajax call
    // de enige reden dat dit hier nog staat is omdat we het wellicht bij acties oid nodig hadden, maar ook
    // daar zouden we via de landing trait en de sessie variabelen moeten kunnen werken
    let aGetParams = URLUtil.getUrlVars();
    let iNrOfPeople = 1; // standaard voegen we 1 persoon toe

    if ( typeof aGetParams.p !== "undefined" )
    {
      // er is een preset aantal personen meegegeven
      iNrOfPeople = parseInt(aGetParams.p);
    }

    for ( let i = 1; i <= iNrOfPeople; i++ )
    {
      //booking_update.addPerson();
    }

    // preset datum
    if ( typeof aGetParams.d !== "undefined" )
    { // ?d=28-03-2025
      let aInputDateParts = aGetParams.d.split('-');

      if ( aInputDateParts.length === 3 )
      {
        let sDay = parseInt(aInputDateParts[0]) + "";
        let sMonth = parseInt(aInputDateParts[1]) + "";
        let sYear = parseInt(aInputDateParts[2]) + "";

        if ( sDay.length === 1 )
        {
          sDay = "0" + sDay;
        }

        if ( sMonth.length === 1 )
        {
          sMonth = "0" + sMonth;
        }

        booking.sPreselectedDate = sDay + "-" + sMonth + "-" + sYear;
        booking.sPreselectedDateDay = parseInt(sDay);
        booking.sPreselectedDateMonth = parseInt(sMonth);
        booking.sPreselectedDateYear = parseInt(sYear);
      }
    }
  }

  static updateWidgetsSharedStateWithExternalInput = () => {

    // roep nu ook dezelfde functies aan als bij het starten van de reserveerstraat om relevante stukken uit de start dat te parsen
    // packagedeals_actions.importFromPageConfigAjaxCall();
    // products_actions.importFromPageConfigAjaxCall();
    // progress_actions.importFromPageConfigAjaxCall();
    // booking_actions.importFromPageConfigAjaxCall();

    widgets.bWasBaseJSONForWidgetsParsed = true;
  }

  static aCachedInputSettingsFromRequest = undefined;
  static _getInputFromGetAndPost = () => {
    if ( typeof InputUtil.aCachedInputSettingsFromRequest !== 'undefined' ) return InputUtil.aCachedInputSettingsFromRequest;

    //Logger.log("processURLData()");
    let aInputSettingsFromRequest = {};

    // GET
    const aGetVars = URLUtil.getUrlVars();

    forEach(aGetVars, function (sGetVal, sGetKey) {
      aInputSettingsFromRequest[sGetKey] = sGetVal;
    });

    // POST via php dump
    if ( typeof window.POST_DATA !== 'undefined' && window.POST_DATA.length > 0 )
    {
      forEach(window.POST_DATA, function (sPostVal, sPostKey) {
        aInputSettingsFromRequest[sPostKey] = sPostVal;
      });
    }

    InputUtil.aCachedInputSettingsFromRequest = aInputSettingsFromRequest;
    return InputUtil.aCachedInputSettingsFromRequest;
  };


}

export default InputUtil;
